<div class="col-xs-8 col-md-8 col-centered col-slider no-padding row">
  <transport-form
    [transport]="transport"
    [freighter]="freighter"
    (saved)="onUpdated($event)"
    (back)="onBackToList()"
  ></transport-form>
</div>
